import type { Locale } from "@/react/story/types";
import { createContext, useContext } from "react";

type Context = {
    all: Locale[];
    count: number;
    goto: (locale: Locale | undefined) => void;
    current: Locale;
    set: (locales: Locale[]) => Promise<void>;
    add: (locale: Locale) => Promise<void>;
    remove: (locale: Locale) => Promise<void>;
    presets: Locale[];
}

export const LocalesContext = createContext<Context>({} as Context);

export const useLocales = () => useContext(LocalesContext);
